import React, { useState, useEffect } from 'react';
import AddDetails from './AddDetails';
import GetDetail from './getdetail';

const Dashboard = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://6vpgfpbqbg.execute-api.ap-south-1.amazonaws.com/getdetails');
      const result = await response.json();
      console.log("Fetched data:", result);
      setData(result.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <div>
      <AddDetails fetchData={fetchData} />
      <GetDetail data={data} />
    </div>
  );
};

export default Dashboard;
